var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input input--number",
      class: { "input--secondary": _vm.secondary }
    },
    [
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _c("input", {
        attrs: {
          type: "number",
          min: _vm.min,
          max: _vm.max,
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.currentValue },
        on: { input: _vm.input }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }